import { ActionCreator } from 'redux';
import { ApiGateway } from '../../components/apiGateway/useApiGateway';
import { ActionTypes, GetFeatureFlagRequestAction } from './actions';

export const getFeatureFlags: ActionCreator<GetFeatureFlagRequestAction> = (api: ApiGateway) =>
    ({ type: ActionTypes.GET_FEATUREFLAGS_REQUEST, api: api });